import React from 'react';
import AutomationsScene from './components/AutomationsScene';
import LeadsScene from './components/LeadsScene';
import CalendarScene from './components/CalendarScene';
import '../../../../components/Scene';

const SCENES = { automations: AutomationsScene, leads: LeadsScene, calendar: CalendarScene };

// Animated, decorative scene for a feature preview. It fills its parent and lets
// its glows and grid bleed past the stage; the parent owns the accessible label.
export default function FeatureIllustration({ feature, t, locale }) {
  const Scene = SCENES[feature] || AutomationsScene;
  return <div className={`studio-feature-art studio-feature-art--${feature}`} aria-hidden="true">
    <div className="studio-feature-art__viewport">
      <Scene key={feature} t={t} locale={locale} />
    </div>
  </div>;
}
